import { faClock } from '@fortawesome/free-solid-svg-icons';
import { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { Card, EventTypeTag, ResourceIdentifier, TaskBar, Value } from '.';
import config from '../config';
import { useAuth } from '../hooks/auth';
import { Event } from '../types';
import formatDate from '../utilities/format-date';
import './EventCard.scss';

type EventCardProps = {
  event: Event;
  [key: string]: any;
};

export function EventCard({ event, ...props }: EventCardProps): ReactElement {
  const { databaseUser: user } = useAuth();

  // The API only includes the event's user for admins; non-admins can only
  // see their own events, so the event's user is the logged-in user
  const eventUser = user?.admin ? event.user : user;

  return (
    <Card className="event-card" {...props}>
      <TaskBar
        left={
          <>
            <Value
              className="event-card-date"
              icon={faClock}
              value={
                <Link to={`/events/${event.id}`}>
                  {formatDate(event.createdAt, config.pageDateFormat)}
                </Link>
              }
              inline
              standalone
            />
            <Value
              className="event-card-user"
              value={
                <ResourceIdentifier
                  resourceType="user"
                  resource={{
                    id: eventUser?.id ?? '',
                    displayName: eventUser?.displayName ?? '',
                  }}
                  link={user?.admin ? undefined : '/profile'}
                  copyable
                />
              }
              inline
              standalone
            />
          </>
        }
        right={
          <Value
            className="event-card-type"
            value={<EventTypeTag eventType={event.type} />}
            inline
            standalone
          />
        }
        background={false}
      />
    </Card>
  );
}
